import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.png'
import _imports_1 from './assets/footer.png'


const _hoisted_1 = { class: "websit_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "毒霸青春版"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "金山毒霸青春版", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "轻快，无广告，更安心", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 珠海海鸟科技有限公司 2022 粤ICP备18107911号 "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "blank",
      href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496822"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("span", null, "粤公网安备 44049102496822号")
    ]),
    /*#__PURE__*/_createTextVNode(" 关注“金山毒霸青春版”微信公众号 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " 地址：广东省珠海市香洲区唐家湾前岛环路323号金山软件园(4号楼) 电话：0756-3327084 ")
], -1)

import { onMounted, onBeforeMount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onBeforeMount(() => {
  location.href='https://young.duba.net/'
})
onMounted(() => {
  report({ showpage: 1 })
})

function clickReport () {
  report({ click: 1 })
}

function report ({showpage = 0, click = 0}) {
  let uuid = localStorage.getItem('uuid')
  if (!uuid) {
    uuid = createUUID(true)
    localStorage.setItem('uuid', uuid)
  }
  let img = new Image()
  img.src = `//helpinfockeniu1.ksmobile.com/g/v1/?product_no=550&showpage=${showpage}&click=${click}&httpurl=&keyid=&source=&public_index=1&business_index=238&ver=1&uuid=${uuid}&tid1=2000&tid2=1&tod1=0&tod2=0&type=0&tryno=6120&iid=0&collect_time=0&lastver=0&svrid=&wtod2=&installtime=&osver=`
}

// 生成uuid
function createUUID(isClient: boolean) {
    var s = [],
        hexDigits = "0123456789abcdef",
        i, uuid;

    for (i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    if (isClient) {
        uuid = s.join("").substr(0, 32);
    } else {
        s[8] = s[13] = s[18] = s[23] = "-";
        uuid = s.join("");
    }
    return uuid;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("a", {
      class: "download_btn",
      href: "//cd001.www.duba.net/duba/install/packages/ever/dubayoung_1_1.exe",
      target: "blank",
      onClick: clickReport
    }, "立即下载"),
    _hoisted_5
  ]))
}
}

})